import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getDefaultValuesForPaymentMethodForm } from "components/pages/paymentMethods/paymentMethodForm/getDefaultValuesForPaymentMethodForm";
import { getErrorMessage } from "helpers";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useGetPaymentMethodByIdQueryProps = {
	entityId: string;
	paymentMethodId: string;
	paymentMethodQueryKey: string;
	getService: Function;
};

const useGetPaymentMethodByIdQuery = ({
	entityId,
	paymentMethodId,
	paymentMethodQueryKey,
	getService,
}: useGetPaymentMethodByIdQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		[paymentMethodQueryKey, paymentMethodId],
		() =>
			getService({
				id: entityId,
				paymentMethodId,
			}),
		{
			select: data => {
				return getDefaultValuesForPaymentMethodForm(data);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			enabled: !!paymentMethodId,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetPaymentMethodByIdQuery;
